import React from 'react'

import { Field } from '../form';
import { indexOf } from 'lodash';
import isURL from 'validator/lib/isURL';
import { scrapeUrl } from '../../api';
import Loading from '../helpers/Loading';
import md5 from 'js-md5';

import get from 'lodash/get';

import { FormSpy } from 'react-final-form';

export const urlScraperDecorator = (urlFieldname, dataFieldName, subscribeTo = { values: true, active: true }) => {
  
  return (form) => {
    const { initialValues } = form.getState();
    let previousActive = null;
    let previousValue = initialValues[urlFieldname];
    let request = null;
    let timeout = null;
    let cache = {};
    
    const defaultValue = null;
    
    const emptyDataField = () =>
      form.change(dataFieldName, defaultValue)
    
    const dataLoading = (isLoading) =>
      form.mutators && form.mutators.setFieldData && form.mutators.setFieldData(dataFieldName, {loading: isLoading});
    
    const setError = (error) =>
      form.mutators && form.mutators.setErrors && form.mutators.setErrors(urlFieldname, error);
    
    const getCache = (url) =>
      cache[md5(url)]
    
    const setCache = (url, data) =>
      cache[md5(url)] = data
    
    if (indexOf(form.getRegisteredFields(), dataFieldName) < 0){
      form.registerField(dataFieldName, ()=>{}, {value: defaultValue, loading: false})
    }
    
    const scrapeUrlToDataField = async (url) =>{
      try{
        if (request && request.cancel && request.isCanceled === false)
          await request.cancel()
        
        if (!getCache(url)){
          request = scrapeUrl({url: url});
          
          const res = await request;
          setCache(url, res);
          request = null;
        }
        const body = getCache(url)
        
        form.batch( () => {
          dataLoading(false)
          
          if (body && !body.error){
            form.change(dataFieldName, body)
          }
          else{
            emptyDataField()
            setError([body.error.statusMessage || body.error])
          }
        });
      }
      catch (e){
        request = null;
      }
    }
    
    const unsubscribe = form.subscribe( async ({ values, active }) => {
      const fields = form.getRegisteredFields()
      
      if (indexOf(fields, dataFieldName) < 0 || (indexOf(fields, urlFieldname) < 0 && !values[urlFieldname]))
        return
      
      const url = (values[urlFieldname] || '').replace(/[\s/]+$/, '');
      const isBlurred = typeof active === 'undefined' && (!previousActive || previousActive === urlFieldname);
      
      previousActive = active;
      if (previousValue === url && !isBlurred)
        return
      
      if (initialValues[urlFieldname] === url && initialValues[dataFieldName])
        return
      
      previousValue = url;
      form.batch( () => {
        setError(null);
        
        if (timeout)
          clearTimeout(timeout);
      
        if ( url && isURL(url) ){
          if (isBlurred || getCache(url)){
            if (!getCache(url))
              dataLoading(true)
            scrapeUrlToDataField(url)
          }
          else{
            if (!request){
              emptyDataField()
              dataLoading(true)
            }
            timeout = setTimeout( () => {scrapeUrlToDataField(url)}, 1500);
          }
        }
        else{
          emptyDataField();
        }
      });
    }, subscribeTo);
    
    return unsubscribe;
  }
}


class UrlScraperComponent extends React.Component {
  
  constructor (props) {
    super(props);
    
    this.request = null;
    this.previousActive = null;
    this.previousValue = null;
    this.timeout = null;
    this.cache = {};
  }
  
    
  getCache (url) {
    const key = md5(url);
    return this.cache[key]
  }
  
  setCache (url, data) {
    const key = md5(url);
    return this.cache[key] = data;
  }
  
  emptyDataField () {
    const { form, dataField, defaultValue } = this.props
    form.change(dataField, defaultValue)
  }

  dataLoading (isLoading) {
    const { form, dataField } = this.props
    form.mutators && form.mutators.setFieldData && form.mutators.setFieldData(dataField, {loading: isLoading});
  }
  
  setError (error) {
    const { form, urlField } = this.props
    form.mutators && form.mutators.setErrors && form.mutators.setErrors(urlField, error);
  }
  
  
  async scrapeUrlToDataField (url){
    const { form, dataField, scrapeFunction, queryParams, passErrors } = this.props;
    const scrapeFn = scrapeFunction || scrapeUrl;
    
    try{
      if (this.request && this.request.cancel && this.request.isCanceled === false)
        await this.request.cancel()
      
      if (!this.getCache(url)){
        this.request = scrapeFn({...(queryParams || {}), url});
        
        try {
          const res = await this.request;
          this.setCache(url, res);
        }
        catch (e){
          if (e && e.response && passErrors === true)
            this.setCache(url, e.response.data);
          else
            throw e
        }
        this.request = null;
      }
      const body = this.getCache(url)
      
      form.batch( () => {
        this.dataLoading(false)
        
        if (body && (!body.error || passErrors === true)){
          form.change(dataField, body);
        }
        else{
          this.emptyDataField()
          this.setError([body.error.statusMessage || body.error])
        }
      });
    }
    catch (e){
      this.dataLoading(false)
      this.emptyDataField()
      this.request = null;
    }
  }
  
  componentWillMount () {
    const { active, values, form, urlField, dataField, defaultValue } = this.props
    const fields = form.getRegisteredFields()
    const value = get(values || {}, urlField);
    
    if (indexOf(fields, dataField) < 0){
      form.registerField(dataField, ()=>{}, {value: defaultValue, loading: false})
    }
    
    this.previousActive = active
    this.previousValue = value
  }
  
  componentWillReceiveProps (nextProps){
    if (nextProps.values === this.props.values && nextProps.active === this.props.active)
      return 
    
    const { form, values, active, urlField, dataField } = nextProps;
    const fields = form.getRegisteredFields()
    const value = get(values, urlField);
    const dataValue = get(values, dataField);
    
    if (indexOf(fields, dataField) < 0 || (indexOf(fields, urlField) < 0 && !value))
      return
    
    const url = (value || '').replace(/[\s/]+$/, '');
    const isBlurred = typeof active === 'undefined' && (!this.previousActive || this.previousActive === urlField);
    
    this.previousActive = active;
    if (this.previousValue === url && (!isBlurred || dataValue))
      return
    
    this.previousValue = url;
    
    form.batch( () => {
      this.setError(null);
      
      if (this.timeout)
        clearTimeout(this.timeout);
    
      if ( url && isURL(url) ){
        if (isBlurred || this.getCache(url)){
          if (!this.getCache(url))
            this.dataLoading(true)
          this.scrapeUrlToDataField(url)
        }
        else{
          if (!this.request){
            this.emptyDataField()
            this.dataLoading(true)
          }
          this.timeout = setTimeout( () => {this.scrapeUrlToDataField(url)}, 1500);
        }
      }
      else{
        this.emptyDataField();
      }
    });
  }
  
  render() {
    return null
  }
}

// Make a HOC
export const UrlScraper = (props) => (
  <FormSpy
    {...props}
    subscription={{ active: true, values: true }}
    component={UrlScraperComponent}
  />
)


export const UrlPreviewPanel = ({ data, loading }) => {
  const {title, image, logo, description} = data;
  
  return (loading || data) ? <div className="url-preview">
    {loading ? <Loading text="Loading preview..." left /> : <div>
      {(image || logo) && <div className="url-image float-left" style={{backgroundImage: `url(${image || logo})`}}></div>}
      {title && <div className="url-title line-clamp">{title}</div>}
      {description && <div className="url-description small gray line-clamp">{description}</div>}
      <div className="clearfix"></div>
    </div>}
  </div> : null
}


export const UrlPreview = (props) => {
  return <Field
      {...props}
      subscription={{ value: true, data: true }}
      render={({ input:{ value }, meta: { data: { loading } } }) =>
        <UrlPreviewPanel data={value} loading={loading} />
      }
    />
}





// WEBPACK FOOTER //
// ./src/components/Links/urlScraper.js